import React, { useState } from "react";
import profileImg from "@assets/images/profile.svg";
import dropdownImg from "@assets/images/arrow-down.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import ChangePassword from "components/common/ChangePassword";
import useProfileController from "view-models/Common/Profile/useProfileController";
import ConfirmationModal from "../ConfirmationModal";
import CircularLoader from "../CircularLoader";
import Button from "@mui/material/Button";
import { commonData } from "data/CommonDataPoint";
import { generalStore } from "store/generalStore";
import { getUserType } from "store/userType";
import useToasterStore from "store/SnackBar/useToasterStore";
import { getFromStorage } from "utils/storage";

function Profile() {
  const {
    isUserType,
    handleClick,
    handleClose,
    handleLogout,
    // handleModalOpen,
    // handleModalClose,
    handleProfileClick,
    handleStatusChange,
    LoginData,
    winDimensions,
    open,
    // modalOpen,
    anchorEl,
    goToOtherPage,
    handleStatusClick,
    isLoading,
    setDeleteModalOpen,
    deleteModalOpen,
    status,
    handleConfirmModelClose,
  } = useProfileController();
  const [isCloseModal, setIsCloseModal] = useState(false);
  const setRoleModalOpen = generalStore((state) => state.setRoleModalOpen);
  const verifyBookingAndFormLoader = generalStore(
    (state) => state.verifyBookingAndFormLoader,
  );

  const setChangePasswordModal = generalStore(
    (state) => state.setChangePasswordModal,
  );
  const changePasswordModal = generalStore(
    (state) => state.changePasswordModal,
  );

  const userData =
    getUserType((state) => state.userData) || getFromStorage("user_data");

  const openToaster = useToasterStore((state) => state.openToaster);

  const multiRoles = JSON.parse(sessionStorage.getItem("roles"));

  return (
    <>
      <div className="mod-profile">
        <div className="profile-info-wrap">
          <h2 className="profile-name">
            {LoginData?.first_Name} {LoginData?.last_Name}
          </h2>
          <p className="profile-type">{LoginData?.user_role}</p>
        </div>
        <div className="profile-img-wrap">
          <img src={profileImg} alt="profile" />
          <span
            className={`status-dot ${status == "break" ? "break" : "active"}`}
          ></span>
        </div>
        <div className="profile-action">
          <img src={dropdownImg} alt="dropdown" />
        </div>
        <button
          className="action-click"
          aria-controls={open ? "fade-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          disabled={verifyBookingAndFormLoader}
          onClick={(event) => {
            // winDimensions[0] <= 768 ? goToOtherPage("/profile") : handleClick();
            if (winDimensions[0] <= 768) {
              handleClick(event);
              // goToOtherPage("/profile");
              document.body.classList.remove("cm-overflow-hidden");
            } else {
              handleClick(event);
            }
          }}
        ></button>

        <Menu
          id="fade-menu"
          className="bs-menu-dropdown typ-profile"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          elevation={0}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {isUserType?.replace(/\s/g, "") == commonData?.salesRole && (
            <>
              <MenuItem
                value={"available"}
                onClick={() => {
                  handleStatusChange(status == "break" ? "available" : "break");
                  handleClose();
                }}
              >
                <div className="mod-tag typ-salesperson-state">
                  <span
                    className={`dot ${status == "break" ? "active" : "break"}`}
                  ></span>
                  <span className="text">
                    {status == "break" ? "Available" : "Break"}
                  </span>
                </div>
              </MenuItem>
              {/* <MenuItem value={"busy"}>
                <div className="mod-tag typ-salesperson-state">
                <span className="dot busy"></span>
                  <span className="text">Busy</span>
                </div>
              </MenuItem> */}
              {/* <MenuItem value={"break"} onClick={()=>handleStatusChange("break")}>
                <div className="mod-tag typ-salesperson-state">
                  <span className="dot break"></span>
                  <span className="text">Break</span>
                </div>
              </MenuItem> */}
              {/* <MenuItem value={"Unavailable"}>
                <div className="mod-tag typ-salesperson-state">
                  <span className="dot unavailable"></span>
                  <span className="text">Unavailable</span>
                </div>
              </MenuItem> */}
            </>
          )}

          {isUserType == "Customer" && (
            <MenuItem
              onClick={() => {
                goToOtherPage(`/${isUserType}/profile`);
                document.body.classList.remove("cm-overflow-hidden");
              }}
            >
              Profile
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleClose();
              setIsCloseModal(true);
              // handleModalOpen();
              setChangePasswordModal(true);
            }}
          >
            Change Password
          </MenuItem>
          {multiRoles?.length > 1 && (
            <MenuItem
              onClick={() => {
                setRoleModalOpen(true);
                // handleClose();
                // setIsCloseModal(true);
                // // handleModalOpen();
                // setChangePasswordModal(true);
              }}
            >
              Switch Role
            </MenuItem>
          )}
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        // open={modalOpen}
        open={changePasswordModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="bs-modal typ-scan"
      >
        {/* <Fade in={modalOpen}> */}
        <Fade in={changePasswordModal}>
          <div className="modal-cont">
            <div className="modal-header">
              <h3 className="title">Change Password</h3>
              <IconButton
                className="bs-btn btn-icon"
                disableRipple
                onClick={() => {
                  if (userData?.password_Reset == "False" && !isCloseModal) {
                    openToaster("error", "Reset Your Password");
                  } else {
                    setChangePasswordModal(false);
                  }
                }}
              >
                <span className="icon icon-close"></span>
              </IconButton>
            </div>
            <div className="modal-body">
              <ChangePassword />
            </div>
          </div>
        </Fade>
      </Modal>

      {/* <ConfirmationModal onDelete={handleStatusClick} id={null} isLoading={isLoading}  /> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={deleteModalOpen}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="bs-modal typ-confirmation-modal"
      >
        <Fade in={deleteModalOpen}>
          <div className="modal-cont">
            <div className="modal-header">
              <IconButton
                className="bs-btn btn-icon"
                disableRipple
                onClick={handleConfirmModelClose}
              >
                <span className="icon icon-close"></span>
              </IconButton>
            </div>
            <div className="modal-body">
              <h3 className="title">
                {status == "break"
                  ? `You want to go on ${status}?`
                  : `You want to be ${status}?`}
              </h3>
              <div className="action-wrap">
                <Button
                  variant="contained"
                  className="bs-btn btn-border"
                  onClick={handleConfirmModelClose}
                >
                  <span className="text">No</span>
                </Button>
                <Button
                  variant="contained"
                  className="bs-btn"
                  onClick={handleStatusClick}
                  disabled={isLoading ? true : false}
                  endIcon={
                    isLoading ? (
                      <CircularLoader loaderClr={"var(--white)"} />
                    ) : (
                      ""
                    )
                  }
                >
                  <span className="text">Yes</span>
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}

export default Profile;
